<template>
	<dl class="taxRateInfo sort-item" v-if="ptInitData.dispTaxRtFlg == 1">
		<dt v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN == '0'">
			<span class="taxInfoTitle">{{ $t('common.labels.taxRate0') }}</span>
		</dt>
		<dt v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'">
			<span class="taxInfoTitle">{{ $t('common.labels.taxRate') }}</span>
		</dt>
		<dd v-if="ptInitData.productInfo.ITEM_ZEI_SET_KBN != '0'">
			<span class="taxInfoValue">
				<span class="taxInfoRt">{{ ptInitData.productInfo.ITEM_ZEI_SET_KBN }}</span>
				<span class="taxInfoPer">{{ $t('common.labels.percentUnit') }}</span>
			</span>
		</dd>
	</dl>
</template>
<script>
export default {
	name: 'TaxRateInfo',
	data: function () {
		return {
		}
	},
	props: {
		ptInitData: {
			type: Object,
			default: null
		}
	},
	methods: {
	}
}
</script>